
(function () {
  var topLevelTitleRoutes = {
    "what's new": '/pages/new-arrivals',
    'whats new': '/pages/new-arrivals',
    'new arrivals': '/pages/new-arrivals',
    'collabs': '/pages/collabs',
    'collaborations': '/pages/collabs',
    'collections': '/pages/collections',
    'eyes': '/pages/eyes',
    'lips': '/pages/lips',
    'face': '/pages/face',
    'nails': '/pages/nails',
    'brushes & tools': '/pages/brushes-tools',
    'brushes and tools': '/pages/brushes-tools',
    'holiday edits': '/pages/collections',
    'colour spell': '/pages/colourspell',
    'colourspell': '/pages/colourspell'
  };

  function cleanTitle(text) {
    return String(text || '').replace(/\s+/g, ' ').replace(/[›>⌄▾▿⌃⌵]/g, '').trim().toLowerCase();
  }

  function isExternalColourSpell(href) {
    if (!href) return false;
    return /^https?:\/\/(www\.)?colourspellcosmetics\.com\/?$/i.test(String(href).trim());
  }

  function isTopLevelNavItem(el) {
    if (!el) return false;
    var li = el.closest('li');
    if (li) {
      if (li.classList.contains('sublink') || li.closest('.submenu, .dropdown, .vertical-menu_submenu, .widemenu__submenu, .mobile-menu__submenu')) return false;
    }
    var parent = el.parentElement;
    while (parent && parent.tagName && parent.tagName.toLowerCase() !== 'header') {
      if (parent.classList && (parent.classList.contains('submenu') || parent.classList.contains('dropdown') || parent.classList.contains('widemenu__submenu'))) return false;
      parent = parent.parentElement;
    }
    return true;
  }

  function targetFor(el) {
    if (el && el.closest('.cs-brand-shell')) return '';
    var href = el.getAttribute('href') || el.getAttribute('data-href') || '';
    if (isExternalColourSpell(href)) return '/pages/colourspell';
    if (!isTopLevelNavItem(el)) return '';
    return topLevelTitleRoutes[cleanTitle(el.textContent)] || '';
  }

  function rewriteLinks() {
    document.querySelectorAll('header a[href], header summary[data-href], header [data-href], .mobile-menu a[href], .mobile-menu [data-href], .vertical-menu a[href], .vertical-menu [data-href]').forEach(function (el) {
      var mapped = targetFor(el);
      if (!mapped) return;
      if (el.tagName && el.tagName.toLowerCase() === 'a') {
        el.setAttribute('href', mapped);
      } else {
        el.setAttribute('data-href', mapped);
        el.setAttribute('data-profusion-hub-link', mapped);
        el.setAttribute('role', 'link');
      }
    });
  }

  function bindHeaderClicks() {
    document.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = event.target && event.target.closest ? event.target.closest('header a[href], header summary[data-href], header [data-profusion-hub-link], .mobile-menu a[href], .mobile-menu [data-profusion-hub-link], .vertical-menu a[href], .vertical-menu [data-profusion-hub-link]') : null;
      if (!target) return;
      var mapped = target.getAttribute('data-profusion-hub-link') || targetFor(target);
      if (!mapped) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.href = mapped;
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewriteLinks); else rewriteLinks();
  window.addEventListener('load', rewriteLinks);
  document.addEventListener('shopify:section:load', rewriteLinks);
  bindHeaderClicks();
})();
